import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "projects/htl-part/src/environments/environment";
import { ConfirmationDialogComponent } from "../shared/confirmation-dialog/confirmation-dialog.component";
import { Passenger, PassengerImage } from "../shared/models/passenger.model";
import { PicturePreviewDialogComponent } from "../shared/picture-preview-dialog/picture-preview-dialog.component";
import { PassengersService } from "./passengers.service";
import { UpdatePassengerDialogComponent } from "./update-passenger-dialog/update-passenger-dialog.component";
import { LocalStorageService } from "../shared/local-storage.service";

@Component({
    selector: "app-passengers",
    templateUrl: "./passengers.component.html",
    styleUrls: ["./passengers.component.scss"],
    standalone: false,
})
export class PassengersComponent implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;

    public displayedColumns: string[] = ["position", "name", "dateOfBirth", "gender", "idCardNumber", "nationality", "idCardImageName", "actions"];
    public passengersList = new MatTableDataSource<Passenger>();

    constructor(
        private _passengersService: PassengersService,
        private _dialog: MatDialog,
        private _translate: TranslateService,
        private _localStorageService: LocalStorageService,
        private _snackBar: MatSnackBar,
        private _router: Router,
        private _route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this._passengersService.getAllPassengers().subscribe((result) => {
            console.log(result);
            const countries = this._localStorageService.getAppLocalStorageObject().countries;
            this.passengersList.data = result;
            this.passengersList.filterPredicate = function (data, filter: string): boolean {
                return (
                    (data.firstName.toLowerCase() + " " + data.lastName.toLowerCase()).includes(filter) ||
                    countries
                        .find((c) => c.id === +data.nationalityId)
                        ?.name.toLowerCase()
                        .includes(filter)
                );
            };
            const queryParams: any = this._route.snapshot.queryParams;
            if (queryParams.modal && queryParams.modal === "edit" && queryParams.id) {
                const id: number = queryParams.id;
                this.onPassengerEditAction(id);
            }
        });

        this._passengersService.onPassengerEdit.subscribe(() => {
            console.log(this._passengersService.getPassengers());
            this.passengersList.data = this._passengersService.getPassengers();
        });
    }

    ngAfterViewInit() {
        this.passengersList.paginator = this.paginator;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.passengersList.filter = filterValue.trim().toLowerCase();
    }

    onPassengerDeleteAction(passengerId: number) {
        const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
            disableClose: true,
            data: this._translate.instant("CONFIRMATIONDIALOG.deleteDataQuestion"),
        });
        dialogRef.afterClosed().subscribe((clickResult) => {
            if (clickResult) {
                this._passengersService.softDeletePassengerById(passengerId).subscribe((result) => {
                    this._snackBar.open(this._translate.instant("GENERAL.deleteSuccessMsg"), this._translate.instant("GENERAL.close"), {
                        duration: 3000,
                    });
                });
            }
        });
    }

    onAddNewPassengerAction() {
        this._dialog.open(UpdatePassengerDialogComponent, {
            disableClose: true,
            width: "50%",
            data: {},
        });
    }

    onPassengerEditAction(passengerId: number) {
        this._dialog
            .open(UpdatePassengerDialogComponent, {
                disableClose: true,
                width: "50%",
                data: {
                    passengerId: passengerId,
                },
            })
            .afterClosed()
            .subscribe(() => {
                this._router.navigate([], {
                    queryParams: {
                        modal: null,
                        id: null,
                    },
                    queryParamsHandling: "merge",
                });
                // this.passengersList.data.map(p => {
                //   if (p.id === passengerId) {
                //     p.imageCount = 1;
                //   }
                // })
            });
    }

    openIdCardImageDialog(passengerId: number) {
        const pathArray: string[] = [];
        const title: string = this._translate.instant("PASSENGERS.idCardPicture");
        this._passengersService.getImagesByPassengerId(passengerId).subscribe((result) => {
            result.map((r) => {
                pathArray.push(environment.imageServerUrl + r.path);
            });
            this._dialog.open(PicturePreviewDialogComponent, {
                disableClose: true,
                width: "30%",
                data: {
                    title,
                    pathArray,
                },
            });
        });
    }
}
